// extracted by mini-css-extract-plugin
var _1 = "desktop-pgfb4";
var _2 = "mobile-wzMQx";
var _3 = "plane-DXHbb";
var _4 = "recipes-Exeo1";
var _5 = "title-oX9lf";
var _6 = "wrapper-tOCzW";
export { _1 as "desktop", _2 as "mobile", _3 as "plane", _4 as "recipes", _5 as "title", _6 as "wrapper" }
